module.exports = __webpack_public_path__ + "img/header-memoireRingsRingsets@2x.a5d5afb.webp";